export const baseImageUrl = "https://www.myshubhlife.com";
export const baseUrl = "https://uat.myshubhlife.com";
export const gatewayUrl = "https://uat-gateway.datasignstech.com";
export const heimdallUrl = "https://uat-gateway.datasignstech.com/heimdall";
export const supportMail = "support@myshubhlife.com";
export const cleverTapUserId = "TEST-KK6-947-795Z";
export const CompanyName = "MyShubhLife";
export const companyInfoUrl = "company-info/";
export const firebaseConfig = {
  apiKey: "AIzaSyDUrzUxDgUrTyAEr7osGx4Zt5x8nIrqVRk",
  authDomain: "uat-shubh-loans.firebaseapp.com",
  databaseURL: "https://uat-shubh-loans.firebaseio.com",
  projectId: "uat-shubh-loans",
  storageBucket: "uat-shubh-loans.appspot.com",
  messagingSenderId: "1077214603431",
  appId: "1:1077214603431:web:aab1eec4a92a2029415382",
  measurementId: "G-VV4YRPX5GT",
};
export const firebaseLoginConfig = {
  apiKey: "AIzaSyBmOEPV2mydScdNB-1saB3F-KjIUg5FOas",
  authDomain: "shubh-loans.firebaseapp.com",
  databaseURL: "https://shubh-loans.firebaseio.com",
  projectId: "shubh-loans",
  storageBucket: "shubh-loans.appspot.com",
  messagingSenderId: "734320453531",
};
export const FE_API_KEY = "8eedccfb6e614f1393de0c9c5b683073";
export const googleClientId =
  "1077214603431-k0gs7k9ot0cn0hgrjl2gpikcifp83msf.apps.googleusercontent.com";
export const googleScript = "https://accounts.google.com/gsi/client";
export const loginVersion = "V2";
export const WebEngageKey = "in~826172c6";
export const EkagrataRazorPayKey = "rzp_test_33rn0qKSn7xray";
export const UgroRazorPayKey = "rzp_test_XNNmY4KtkxIAdI";
export const ConsentAndroidRedirect =
  "https://uat.myshubhlife.com/consent/#/redirection";
export const ConsentWebAppRedirect =
  "https://uat.myshubhlife.com/consent/#/redirection";
export const UDYAM_KYC_KEY = "975f62eb-bf2a-4075-a72f-a1d484f55780"
